module.exports = __webpack_public_path__ + "img/Mobile_order_hit02.1a72c774.png";